import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44030df7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center"} }, "Add Roommate", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("red", null, "*")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { style: {"text-align":"center"} }
const _hoisted_12 = ["disabled"]

import { InsuranceUser } from "@/models/InsuranceUser";
import { onMounted, ref, computed, onUnmounted } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import useModal from "@/hooks/useModal";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUserModal',
  props: {
  name: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;


const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name);
const user = ref(new InsuranceUser());
const quote = useQuoteStore();

onMounted(() => {
  user.value = new InsuranceUser();
});

onUnmounted(() => {
  onModalDestroy(props.name);
});

function addUser() {
  quote.checkout.roommates.push(user.value);
  toggleModal(props.name);
  user.value = new InsuranceUser();
}

function onShow() {
  // Reset user on new show
  user.value = new InsuranceUser();
}

const validated = computed(() => {
  return user.value.firstName && user.value.lastName;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(modalClass))
  }, [
    _createElementVNode("div", {
      class: "content",
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleModal)(__props.name)))
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(__props.name)))
      }, "X"),
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.firstName) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, user.value.firstName]
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.lastName) = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, user.value.lastName]
        ])
      ]),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          disabled: !validated.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addUser()))
        }, "Add", 8, _hoisted_12)
      ])
    ], 32)
  ], 2))
}
}

})